export default __webpack_public_path__ + "assets/8d7fdcd3a408ac11b3582aa80b205d56.svg";